// src/utils/phoneVerificationBypass.ts

import { PHONE_VERIFICATION_BYPASS_ORG_ID } from '@/constants';
import { getJwtClaim } from '@/utils/jwtDecoder';
import { getSessionToken } from '@/utils/sessionStorage';

/**
 * Organizations without usable phone numbers skip the phone-verification
 * screens; the backend accepts a fixed phone code for them instead.
 * The organizationId claim comes from whichever token carries the flow's
 * identity: the registration token during sign-up, the recovery token
 * during password reset.
 */
export function isPhoneVerificationBypassToken(token: string | null | undefined): boolean {
  if (token === null || token === undefined || token === '') return false;

  const organizationId = getJwtClaim<'organizationId', string>(token, 'organizationId');
  return organizationId === PHONE_VERIFICATION_BYPASS_ORG_ID;
}

/** Registration-flow check: reads the registration token stored after OTP verification. */
export function shouldBypassPhoneVerification(): boolean {
  return isPhoneVerificationBypassToken(getSessionToken());
}
